export var Type;
(function (Type) {
    Type["String"] = "string";
    Type["BoundedString"] = "bstring";
    Type["Int8"] = "int8";
    Type["Int16"] = "int16";
    Type["Int32"] = "int32";
    Type["BoundedInt"] = "bounded_int";
    Type["Float64"] = "float64";
    Type["BoundedFloat"] = "bounded_float";
    Type["Boolean"] = "boolean";
    Type["Array"] = "array";
    Type["BoundedArray"] = "barray";
    Type["FixedArray"] = "farray";
    Type["Object"] = "object";
    Type["Option"] = "option";
    Type["Union"] = "union";
    Type["Constant"] = "literal";
    Type["Something"] = "something";
    Type["BoundedMap"] = "bmap";
})(Type || (Type = {}));
//string|number|Array<Literal>|{[key: string]: Literal};
function isOptionType(format) {
    if (Array.isArray(format) && format[0] === Type.Option) {
        if (format.length !== 2) {
            throw new Error('Invalid option format (expected 2 elements): ' + JSON.stringify(format));
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
}
export function checkFormat(format, literal, options) {
    var _a;
    const strict = (_a = options === null || options === void 0 ? void 0 : options.strict) !== null && _a !== void 0 ? _a : true;
    if (Array.isArray(format)) {
        if (format.length < 1) {
            throw new Error('Invalid format: ' + JSON.stringify(format));
        }
        else {
            const t = format[0];
            switch (t) {
                case Type.BoundedString:
                    if (typeof (literal) !== 'string') {
                        return false;
                    }
                    else {
                        return literal.length <= format[1];
                    }
                case Type.BoundedInt:
                    if (format.length !== 3) {
                        throw new Error('Invalid format (expected 3 elements): ' + JSON.stringify(format));
                    }
                    else if (typeof (format[1]) !== 'number' || typeof (format[2]) !== 'number') {
                        throw new Error('Invalid format (expected number for int bounds in positions 1 and 2): ' + JSON.stringify(format));
                    }
                    else if (!Number.isInteger(format[1]) || !Number.isInteger(format[2])) {
                        throw new Error('Invalid format (expected integer for int bounds in positions 1 and 2): ' + JSON.stringify(format));
                    }
                    else if (typeof (literal) !== 'number') {
                        return false;
                    }
                    else if (!Number.isInteger(literal)) {
                        return false;
                    }
                    else if (literal < format[1] || literal > format[2]) {
                        return false;
                    }
                    else {
                        return true;
                    }
                case Type.BoundedFloat:
                    if (format.length !== 3) {
                        throw new Error('Invalid format (expected 3 elements): ' + JSON.stringify(format));
                    }
                    else if (typeof (format[1]) !== 'number' || typeof (format[2]) !== 'number') {
                        throw new Error('Invalid format (expected number for float bounds in positions 1 and 2): ' + JSON.stringify(format));
                    }
                    else if (typeof (literal) !== 'number' || !Number.isFinite(literal)) {
                        return false;
                    }
                    else {
                        return literal >= format[1] && literal <= format[2];
                    }
                case Type.Array:
                    if (format.length !== 2) {
                        throw new Error('Invalid format (expected 2 elements): ' + JSON.stringify(format));
                    }
                    else {
                        if (!Array.isArray(literal)) {
                            return false;
                        }
                        else {
                            return literal.every((item) => checkFormat(format[1], item, options));
                        }
                    }
                case Type.BoundedArray:
                    if (format.length !== 3) {
                        throw new Error('Invalid format (expected 3 elements): ' + JSON.stringify(format));
                    } /* else if (typeof(format[1]) !== 'object' || Array.isArray(format[1])) {
                        throw new Error('Invalid format (expected format for array elements in position 1): ' + JSON.stringify(format));
                    }*/
                    else if (typeof (format[2]) !== 'number') {
                        throw new Error('Invalid format (expected number for array length in position 2): ' + JSON.stringify(format));
                    }
                    else if (!Number.isInteger(format[2])) {
                        throw new Error('Invalid format (expected integer for array length in position 2): ' + JSON.stringify(format));
                    }
                    else if (!Array.isArray(literal)) {
                        return false;
                    }
                    else {
                        return literal.length <= format[2] && literal.every((item) => checkFormat(format[1], item, options));
                    }
                case Type.FixedArray:
                    if (format.length !== 3) {
                        throw new Error('Invalid format (expected 3 elements): ' + JSON.stringify(format));
                    }
                    else if (typeof (format[1]) !== 'number') {
                        throw new Error('Invalid format (expected number for tuple length in position 1): ' + JSON.stringify(format));
                    }
                    else if (!Number.isInteger(format[1])) {
                        throw new Error('Invalid format (expected integer for tuple length in position 1): ' + JSON.stringify(format));
                    }
                    else if (!Array.isArray(literal)) {
                        return false;
                    }
                    else {
                        return literal.length === format[2] && literal.every((item) => checkFormat(format[1], item, options));
                    }
                case Type.Constant:
                    if (format.length !== 2) {
                        throw new Error('Invalid format (expected 2 elements): ' + JSON.stringify(format));
                    }
                    else if (typeof (format[1]) !== 'string' && typeof (format[1]) !== 'number' && typeof (format[1]) !== 'boolean') {
                        throw new Error('Invalid format (expected string, number, or boolean for literal in position 1): ' + JSON.stringify(format));
                    }
                    else {
                        return literal === format[1];
                    }
                case Type.BoundedMap:
                    if (format.length !== 4) {
                        throw new Error('Invalid format (expected 4 elements): ' + JSON.stringify(format));
                    }
                    else if (typeof (format[3]) !== 'number' || !Number.isInteger(format[3])) {
                        throw new Error('Invalid format (expected integer for max entries in position 3): ' + JSON.stringify(format));
                    }
                    else if (typeof (literal) !== 'object' || Array.isArray(literal)) {
                        return false;
                    }
                    else {
                        const keys = Object.keys(literal);
                        if (keys.length > format[3])
                            return false;
                        for (const key of keys) {
                            if (!checkFormat(format[1], key, options))
                                return false;
                            if (!checkFormat(format[2], literal[key], options))
                                return false;
                        }
                        return true;
                    }
                case Type.Union:
                    if (format.length !== 2) {
                        throw new Error('Invalid format (expected 2 elements): ' + JSON.stringify(format));
                    }
                    else if (!Array.isArray(format[1])) {
                        throw new Error('Invalid format (expected array for union elements in position 1): ' + JSON.stringify(format));
                    }
                    else {
                        return format[1].some((item) => checkFormat(item, literal, options));
                    }
                default:
                    throw new Error('Invalid format (expected format for array elements in position 1): ' + JSON.stringify(format));
            }
        }
    }
    else if (typeof (format) === 'object') {
        if (typeof (literal) !== 'object' || Array.isArray(literal)) {
            return false;
        }
        else {
            const formatKeys = new Set(Object.keys(format));
            for (const [key, keyFormatOpt] of Object.entries(format)) {
                let keyFormat;
                let optional;
                if (isOptionType(keyFormatOpt)) {
                    keyFormat = keyFormatOpt[1];
                    optional = true;
                }
                else {
                    keyFormat = keyFormatOpt;
                    optional = false;
                }
                if (literal.hasOwnProperty(key)) {
                    const value = literal[key];
                    if (!checkFormat(keyFormat, value, options)) {
                        return false;
                    }
                }
                else {
                    if (!optional) {
                        return false;
                    }
                }
            }
            if (strict) {
                for (const key of Object.keys(literal)) {
                    if (!formatKeys.has(key)) {
                        return false;
                    }
                }
            }
            return true;
        }
    }
    else if (typeof (format) === 'string') {
        if (format === Type.String) {
            return typeof (literal) === 'string';
        }
        else if (format === Type.Int8 || format === Type.Int16 || format === Type.Int32) {
            if (typeof (literal) !== 'number' || !Number.isInteger(literal)) {
                return false;
            }
            else {
                if (format === Type.Int8) {
                    return literal >= -128 && literal <= 127;
                }
                else if (format === Type.Int16) {
                    return literal >= -32768 && literal <= 32767;
                }
                else if (format === Type.Int32) {
                    return literal >= -2147483648 && literal <= 2147483647;
                }
                else {
                    return false;
                }
            }
        }
        else if (format === Type.Float64) {
            if (typeof (literal) !== 'number') {
                return false;
            }
            else {
                return Number.isFinite(literal);
            }
        }
        else if (format === Type.Boolean) {
            return typeof (literal) === 'boolean';
        }
        else if (format === Type.Something) {
            return literal !== undefined && literal !== null;
        }
        else {
            throw new Error('Invaled format type: ' + JSON.stringify(format));
        }
    }
    else {
        throw new Error('Invalid format: ' + JSON.stringify(format));
    }
}
